const getDefaultState = () => {
  return {
    userInfoSoftbank: {},
    chargeInfoSoftbank: {},
    urlMigration: ''
  }
};
const state = getDefaultState();

const getters = {
  getUserInfoSoftbank (state) {
    return state.userInfoSoftbank
  },
  getChargeInfoSoftbank (state) {
    return state.chargeInfoSoftbank
  },
  getUrlMigration (state) {
    return state.urlMigration
  }
};

const mutations = {
  SET_USER_INFO_SOFTBANK (state, payload) {
    state.userInfoSoftbank = payload;
  },
  SET_CHARGE_INFO_SOFTBANK (state, payload) {
    state.chargeInfoSoftbank = payload;
  },
  SET_URL_MIGRATION (state, payload) {
    state.urlMigration = payload;
  },
  CLEAR_USER_INFO (state) {
    state.userInfoSoftbank = {}
  },
  CLEAR_CHARGE_INFO (state) {
    state.chargeInfoSoftbank = {}
  },
  CLEAR_URL_MIGRATION (state) {
    state.urlMigration = ''
  }
};

export default {
  state, mutations, getters
};



// WEBPACK FOOTER //
// ./src/stores/modules/softBankStore.js